import { SecondaryButton, TertiaryButton } from '@moonpig/launchpad-components'
import React, { FC } from 'react'
import { useExperimentBoolean } from '@moonpig/web-core-eppo/browser'
import { useAuthenticationLocaleText } from '../../../../text-localisation'

export type SignInWithPasswordButtonProps = {
  onClick: (e: React.FormEvent) => void
}

export const SignInWithPasswordButton: FC<
  SignInWithPasswordButtonProps
> = props => {
  const localiseText = useAuthenticationLocaleText()

  const featureCustomCodeInput = useExperimentBoolean(
    'customer-auth-custom-code-input',
    { fallback: false },
  )

  if (featureCustomCodeInput) {
    return (
      <TertiaryButton
        width="100%"
        height={'24px'}
        minHeight={'24px'}
        onClick={props.onClick}
        type="button"
        style={{
          textDecoration: 'none',
          padding: 0,
        }}
      >
        {localiseText('sign_in_with_password.button')}
      </TertiaryButton>
    )
  }

  return (
    <SecondaryButton width="100%" mb={6} onClick={props.onClick} type="button">
      {localiseText('sign_in_with_password.button')}
    </SecondaryButton>
  )
}
